import { ABTestAskCoverageV4 } from '../../utils/enabled_features/ab_tests';
import { StepCategory, type AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { growthBookInstance } from '../../utils/analytics/growthbook';

/**
 * Collect the information of whether user wants higher or lower coverages.
 */
export const CoverageOnboardingStep: Step = {
  id: 'askCoverage',
  pathname: '/coverage',
  canShow: (appData: AppData) => {
    if (!appData.selectedService?.insurance) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    if (!appData.signupParams?.isAutoInsured) {
      return false;
    }

    const askCoverageV4Variant = growthBookInstance?.getFeatureValue(ABTestAskCoverageV4.storageKey, 0);
    if (!appData.isOnboardingLite && !appData.featureData?.askICVBeforeOnboarding) {
      return askCoverageV4Variant === 1 || askCoverageV4Variant === 2 || askCoverageV4Variant === 3;
    }

    return false;
  },
  hasData: () => true,
  hasOwnData: (appData) => appData.signupParams?.bodilyInjuryTier !== undefined,
  category: () => StepCategory.Insurance,
};
